import { INSCRIPCIONES_URL, DELETE_INSCRIPCION_URL, LLAMADOS_URL } from '../config';
import axios from 'axios';


// READ
export function getInscripcionesByUser() {
  return axios.get(INSCRIPCIONES_URL);
}

export function deleteInscripcion(inscripcionId) {
  const url = `${DELETE_INSCRIPCION_URL}?inscripcionId=${inscripcionId}`
  return axios.delete(url);
}

export function getLlamados() {
  return axios.get(LLAMADOS_URL);
}